import { render, staticRenderFns } from "./ArticleHotIndexContainer.vue?vue&type=template&id=00a21cac&"
import script from "./ArticleHotIndexContainer.vue?vue&type=script&lang=js&"
export * from "./ArticleHotIndexContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports